import React from 'react';
import { BasicButton } from '@payer-admin-ui/components-v2/src/buttons/BasicButton';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useTranslation } from 'react-i18next';
import { ClearFiltersButton } from '../Button/ClearFiltersButton';

type FilterButtonsInput = {
  onOpen: React.MouseEventHandler<HTMLButtonElement>;
  disableClearButton: boolean;
  onClear: React.MouseEventHandler<HTMLButtonElement>;
};

export const FilterButtons = ({ onOpen, disableClearButton, onClear }: FilterButtonsInput) => {
  const { t } = useTranslation();
  return (
    <>
      <BasicButton size="large" onClick={onOpen} startIcon={<FilterAltIcon />}>
        {t('filter.filters')}
      </BasicButton>
      <ClearFiltersButton disabled={disableClearButton} onClick={onClear} />
    </>
  );
};
